import { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  MenuItem,
  Typography,
  Container,
  Table,
  TableHead,
  TableRow,
  TableCell,
  List,
  ListItem,
  ListItemText,
  TableBody,
} from "@mui/material";
import { createApiCall } from "../api/api-service";

const MultiFileUploader = () => {
  const [files, setFiles] = useState([]);
  const [status, setStatus] = useState([]);
  const fileInputRef = useRef();
  const [brands, setBrands] = useState([]);
  const [formData, setFormData] = useState({
    brand: "",
    category: "",
  });
  const [categories, setCategories] = useState([]);
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles(selectedFiles);
    setStatus("");
  };

  const fetch_category_list = async () => {
    const data = await createApiCall("GET", "inventory/fetch_category");
    setCategories(data);
  };
  const fetchBrandData = async () => {
    const data = await createApiCall("GET", "inventory/fetch_brands");
    setBrands(data);
  };
  useEffect(() => {
    fetch_category_list();
    fetchBrandData();
  }, []);

  const handleClear = () => {
    setFiles([]);
    setStatus("");
    if (fileInputRef.current) fileInputRef.current.value = null;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpload = async () => {
    if (files.length === 0) {
      setStatus("No files selected.");
      return;
    }

    const formRequest = new FormData();
    files.forEach((file, index) => {
      formRequest.append("files", file); // Use 'files' as Django expects a list
    });

    formRequest.append('brand_id',formData.brand)
    formRequest.append('category_id',formData.category)
    let brand_name = brands.find((val) => {
      return val?.brand_id == formData.brand;
    });
    formRequest.append("ecom_name", brand_name?.brand_name);


    try {
      const response = await createApiCall(
        "POST",
        "inventory/add_bulk_variant",
        formRequest,
        true,
        {
          "Content-Type": "multipart/form-data",
        }
      );

      if (response?.response === "000") {
        setStatus(response?.data);
      } else {
        setStatus("Upload Failed");
      }
    } catch (error) {
      console.error(error);
      setStatus("Upload failed.");
    }
  };

  return (
    <Box sx={{ maxWidth :'500px',mx: "auto", mt: 4, textAlign: "center" }}>
      <Typography variant="h6" gutterBottom>
        Upload Multiple Product
      </Typography>
      <TextField
        select
        label="Brand"
        name="brand"
        value={formData.brand}
        size="medium"
        onChange={handleChange}
        fullWidth
      >
        {brands.map((brand) => (
          <MenuItem key={brand?.brand_id} value={brand?.brand_id}>
            {brand?.brand_name}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        select
        label="Category"
        name="category"
        value={formData.category}
        size="medium"
        onChange={handleChange}
        fullWidth
      >
        {categories.map((cat) => (
          <MenuItem key={cat?.category_id} value={cat?.category_id}>
            {cat?.category_name}
          </MenuItem>
        ))}
      </TextField>
      <input
        type="file"
        ref={fileInputRef}
        multiple
        onChange={handleFileChange}
        style={{ marginBottom: "16px" }}
      />

      {files.length > 0 && (
        <List dense>
          {files.map((file, index) => (
            <ListItem key={index}>
              <ListItemText primary={file.name} />
            </ListItem>
          ))}
        </List>
      )}

      <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 2 }}>
        <Button
          variant="contained"
          onClick={handleUpload}
          disabled={files.length === 0}
        >
          Upload
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleClear}
          disabled={status.length === 0}
        >
          Clear
        </Button>
      </Box>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>File name</TableCell>
            <TableCell>status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          { status.length !=0 && status.map((product, i) => (
            <TableRow key={i}>
              <TableCell>{product.file_name}</TableCell>
              <TableCell>{product.status}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default MultiFileUploader;
